module.exports = __webpack_public_path__ + "static/media/ic_audio_deactivate.8d483861.svg";